export default Object.freeze({
  hideColumns: {},
  filterConfig: [
    {
      name: 'recoveryTypeName',
      filtername: 'recoveryTypes',
      type: 'multi-checkbox',
      groupId: 1,
      sequence: 0,
    },
    {
      name: 'regionName',
      filtername: 'regionCodes',
      type: 'multi-select',
      groupId: 1,
      sequence: 1,
    },
    {
      name: 'clusterName',
      filtername: 'clusterCodes',
      type: 'multi-select',
      groupId: 1,
      sequence: 2,
    },
    {
      name: 'countryName',
      filtername: 'countryCodes',
      type: 'multi-select',
      groupId: 1,
      sequence: 3,
    },
  ],
});
